// ファイルサイズ (Byte) 表示
//
// 例) 1024B -> 1KB
//
// そこまで汎用的にするつもりもないので小数点以下第2位
// を四捨五入します。

function filesizeRound(value) {
  return Math.round(value * 100) / 100
}

export function filesize(sizeInByte) {
  if (sizeInByte < 1024) {
    return `${sizeInByte} B`
  }

  const sizeInKiloByte = filesizeRound(sizeInByte / 1024)
  const sizeInMegaByte = filesizeRound(sizeInKiloByte / 1024)
  const sizeInGigaByte = filesizeRound(sizeInMegaByte / 1024)

  if (sizeInGigaByte >= 1) {
    return `${sizeInGigaByte} GB`
  }

  if (sizeInMegaByte >= 1) {
    return `${sizeInMegaByte} MB`
  }

  return `${sizeInKiloByte} KB`
}
